import { render, staticRenderFns } from "./NotificationViewList.vue?vue&type=template&id=6d0f6481&"
import script from "./NotificationViewList.vue?vue&type=script&lang=ts&"
export * from "./NotificationViewList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports